module.exports = __webpack_public_path__ + "static/media/carousel8.e60a3d79.jpeg";